import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SpinnerState } from '../constantes/spinner-state.enum';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly isLoading = new BehaviorSubject<SpinnerState>(SpinnerState.START);

  get isLoading$(): Observable<SpinnerState> {
    return this.isLoading;
  }

  afficher(): void {
    this.isLoading.next(SpinnerState.VISIBLE);
  }

  cacher(): void {
    this.isLoading.next(SpinnerState.CACHE);
  }
}
